// removed by extract-text-webpack-plugin
module.exports = {"intellectualPropertyView":"styles__intellectualPropertyView___mw9C7","email":"styles__email___1vF44","preContent":"styles__preContent___3JFil","authorListAndDownload":"styles__authorListAndDownload___3FURY","downloadPrintablePDF":"styles__downloadPrintablePDF___2VIV6","downloadIcon":"styles__downloadIcon___s6H-m","rotate":"styles__rotate___2xR86","fadein":"styles__fadein___2NOK4","slideFromRight":"styles__slideFromRight___2Jd30","waves":"styles__waves___2HQee"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/IntellectualPropertyView/styles.scss
// module id = ./resources/assets/js/components/IntellectualPropertyView/styles.scss
// module chunks = 0